import React, { useEffect, createElement } from 'react';
const pixelId = '1497007874735639';
type PixelFunction = {
  (...args: unknown[]): void;
  queue: unknown[][];
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: PixelFunction;
    _fbq?: PixelFunction;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) return;
    const fbq = ((...args: unknown[]) => {
      fbq.queue.push(args);
    }) as PixelFunction;
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
    window._fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', pixelId);
    fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-82">
      <img alt="" height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`} data-id="element-83" />
    </noscript>;
}